type VerificationEvent = "view" | "resend";
type PendingVerification = {
  challenge: string;
  userId?: string;
  startedAt: number;
  viewed: boolean;
  events: (() => void)[];
};

let pending: PendingVerification | undefined;
const MAX_AGE_MS = 30 * 60 * 1000;

export const deferVerificationEvent = (
  challenge: string,
  event: VerificationEvent,
  send: () => void
): void => {
  if (
    !pending ||
    pending.challenge !== challenge ||
    Date.now() - pending.startedAt > MAX_AGE_MS
  )
    pending = { challenge, startedAt: Date.now(), viewed: false, events: [] };
  if (event === "view" && pending.viewed) return;
  if (event === "view") pending.viewed = true;
  if (pending.events.length < 20) pending.events.push(send);
};

export const replaceVerificationChallenge = (
  previous: string,
  next: string
): void => {
  if (pending?.challenge === previous) pending.challenge = next;
};

export const bindVerificationUser = (
  challenge: string,
  userId: string
): void => {
  if (pending?.challenge === challenge) pending.userId = userId;
};

export const clearVerificationEvents = (): void => {
  pending = undefined;
};

export const flushVerificationEvents = (
  userId: string | undefined,
  allowed: boolean
): void => {
  if (!pending?.userId || pending.userId !== userId) return;
  const events = pending.events;
  const expired = Date.now() - pending.startedAt > MAX_AGE_MS;
  clearVerificationEvents();
  if (allowed && !expired)
    events.forEach((send) => {
      try {
        send();
      } catch {}
    });
};
